import React, { useState } from "react";


import { IProps } from "./types";
import { getPreviewURL } from "../../dashboard/Meta/Additional/VideosEditor/utils";
import { getPhotoURL } from "../../dashboard/Meta/Additional/PhotoGaleryEditor/utils";
import { Arrows, Container, GaleryContainer, Next, Prev, VideoIcon } from "./styles";
import classNames from "classnames";
import Icon from "../../../../icon";
import { FormattedMessage } from "react-intl";
import messages from "./messages";
import { YoutubeIcon } from "../../../components/SocialIcons";

const getLastPage = (totalItems: number) => {
    if (!process.env.WEBPACK) {
        return totalItems - 1;
    }
    if (window.innerWidth >= 1200) {
        return totalItems - 2;
    }
    return totalItems - 1;
}

const Additional = ({ additional, scrollToApply }: IProps) => {
    const [page, setPage] = useState(0);
    const totalItems = additional.videos.length + additional.photos.length;
    if (totalItems === 0) {
        return null;
    }

    const isMobile = process.env.WEBPACK ? window.innerWidth < 1200 : false;
    return (
        <Container style={{
            backgroundImage: `url('/images/polygon_back.svg')`,
        }}>
            <h3><FormattedMessage {...messages.gallery} /></h3>

            <GaleryContainer>
                {additional.videos.map((videoId, index) => (
                    <div key={videoId} className={classNames({ lgVisible: index >= page && index <= page + 1 }, `page-${page}`)}>
                        <a href={`https://youtube.com/watch?v=${videoId}`} target="_blank">
                            <div className="video-preview" style={{ backgroundImage: `url(${getPreviewURL(videoId)})` }} />
                            <VideoIcon>
                                <YoutubeIcon />
                            </VideoIcon>
                        </a>
                    </div>
                ))}
                {additional.photos.map((photoId, index) => (
                    <div key={photoId} className={classNames({ lgVisible: additional.videos.length + index >= page && additional.videos.length + index <= page + 1 }, `page-${page}`)}>
                        <img src={getPhotoURL(photoId)} />
                    </div>
                ))}
            </GaleryContainer>
            {getLastPage(totalItems) - (totalItems - getLastPage(totalItems)) > (isMobile ? -1 : -2) && (
                <Arrows>
                    <Prev
                        type="button"
                        data-role="none"
                        onClick={() => {
                            if (page === 0) {
                                setPage(getLastPage(totalItems));
                            } else {
                                setPage(oldPage => oldPage - 1);
                            }
                        }}
                    >
                        <Icon i="chevron-right" />
                    </Prev>
                    <Next
                        type="button"
                        data-role="none"
                        onClick={() => {
                            if (page === getLastPage(totalItems)) {
                                setPage(0);
                            } else {
                                setPage(oldPage => oldPage + 1);
                            }
                        }}
                    >
                        <Icon i="chevron-right" />
                    </Next>
                </Arrows>
            )}
            <button className="button" onClick={scrollToApply}>
                <FormattedMessage {...messages.apply} />
            </button>
        </Container>
    );
};

export default Additional;
